import PcHeader from '@/views/layout/pc/Header';
import PcFooter from '@/views/layout/pc/Footer';

import { Role } from '@/helpers/role';

import PcLogin from '@/views/components/pc/Login/Login';
import PcResetPassword from '@/views/components/pc/ResetPassword/ResetPassword';
import PcVoucherList from '@/views/components/pc/Voucher/List';
import PcInputTour from '@/views/components/pc/Tour/Input';
import PcAfterInputTour from '@/views/components/pc/Tour/AfterInput';
import PcAddVoucher from '@/views/components/pc/Voucher/Add';
import PcContracts from '@/views/components/pc/Voucher/Contracts';
import PcSubContracts from '@/views/components/pc/Voucher/SubContract';
import PcLoginFirstMfa from '@/views/components/pc/Login/LoginFirstMfa';
import PcLoginMfa from '@/views/components/pc/Login/LoginMfa';

const routerPC = [
    {
        path: '/login',
        name: 'PcLogin',
        components: {
            pcbody: PcLogin,
            pcfooter: PcFooter,
        },
        meta: {
            public: true,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/login/mfa/first',
        name: 'PcLoginFirstMfa',
        components: {
            pcbody: PcLoginFirstMfa,
            pcfooter: PcFooter,
        },
        meta: {
            public: true,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/login/mfa',
        name: 'PcLoginMfa',
        components: {
            pcbody: PcLoginMfa,
            pcfooter: PcFooter,
        },
        meta: {
            public: true,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/',
        redirect: '/tour/input',
        name: 'Home',
        components: {},
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/changepassword',
        name: 'PcResetPassword',
        components: {
            pcbody: PcResetPassword,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/tour/input',
        name: 'PcInputTour',
        components: {
            pcheader: PcHeader,
            pcbody: PcInputTour,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },

    {
        path: '/tour/after-input',
        name: 'AfterInputTour',
        components: {
            pcheader: PcHeader,
            pcbody: PcAfterInputTour,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/list',
        name: 'PcVoucherIndex',
        components: {
            pcheader: PcHeader,
            pcbody: PcVoucherList,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/contracts',
        name: 'PcVoucherContracts',
        components: {
            pcheader: PcHeader,
            pcbody: PcContracts,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/subContracts',
        name: 'PcVoucherSubContracts',
        components: {
            pcheader: PcHeader,
            pcbody: PcSubContracts,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/voucher/add',
        name: 'PcAddVoucher',
        components: {
            pcheader: PcHeader,
            pcbody: PcAddVoucher,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.User.id, Role.Cooperator.id, Role.ReadOnly.id],
        },
    },
];

export default routerPC;



// WEBPACK FOOTER //
// ./src/router/pc.js